import React from 'react';
import { FaArrowRight } from 'react-icons/fa';

// --- Stat Card ---
export const StatCard = ({ title, value, icon: Icon, color, trend }) => {
  const colorMap = {
    green: 'bg-emerald-100 text-emerald-600',
    blue: 'bg-blue-100 text-blue-600',
    purple: 'bg-purple-100 text-purple-600',
    yellow: 'bg-yellow-100 text-yellow-600',
    red: 'bg-red-100 text-red-600',
  };

  const bgClass = colorMap[color] || colorMap.green;

  return (
    <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100 hover:shadow-md transition-shadow">
      <div className="flex items-center justify-between mb-4">
        <div className={`w-12 h-12 rounded-xl flex items-center justify-center text-xl ${bgClass}`}>
          <Icon />
        </div>
        {trend && (
          <span className={`text-xs font-bold px-2 py-1 rounded-full ${trend > 0 ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-700'}`}>
            {trend > 0 ? '+' : ''}{trend}%
          </span>
        )}
      </div>
      <div>
        <p className="text-sm font-medium text-slate-500 uppercase tracking-wide">{title}</p>
        <h3 className="text-2xl font-black text-slate-800 mt-1">{value}</h3>
      </div>
    </div>
  );
};

// --- Section Header ---
export const SectionHeader = ({ title, linkText, linkTo, onClick }) => (
  <div className="flex items-center justify-between mb-6">
    <h2 className="text-xl font-bold text-slate-800">{title}</h2>
    {(linkText && (linkTo || onClick)) && (
      <button 
        onClick={onClick} // Handle onClick if provided
        className="text-sm font-semibold text-emerald-600 hover:text-emerald-700 flex items-center group transition-colors"
      >
        {linkText} <FaArrowRight className="ml-1 group-hover:translate-x-1 transition-transform" />
      </button>
    )}
  </div>
);

// --- Activity List Item ---
export const ActivityListItem = ({ title, subtitle, date, status, statusColor, action }) => (
  <div className="group flex items-center justify-between p-4 bg-white border border-slate-100 rounded-xl hover:border-emerald-200 hover:shadow-sm transition-all">
    <div className="flex items-center space-x-4">
      <div className="w-10 h-10 rounded-full bg-slate-50 flex items-center justify-center text-slate-400 font-bold text-sm group-hover:bg-emerald-50 group-hover:text-emerald-600 transition-colors">
        {title.charAt(0)}
      </div>
      <div>
        <h4 className="font-bold text-slate-800 text-sm group-hover:text-emerald-700 transition-colors line-clamp-1">{title}</h4>
        <p className="text-xs text-slate-500">{subtitle} • {date}</p>
      </div>
    </div>
    <div className="flex items-center space-x-4">
      {status && (
        <span className={`px-3 py-1 rounded-full text-xs font-bold ${statusColor}`}>
          {status}
        </span>
      )}
      {action && (
        <div>{action}</div>
      )}
    </div>
  </div>
);
